/**
 * Zone.js configuration flags.
 * This file must be loaded BEFORE zone.js in the polyfills array.
 *
 * - PASSIVE_EVENTS: Registers scroll-related events as passive by default.
 * - __Zone_disable_requestAnimationFrame: Prevents Zone.js from patching
 *   requestAnimationFrame, so rAF callbacks don't trigger change detection.
 * - __Zone_disable_timers: Prevents Zone.js from patching setTimeout and setInterval,
 *   so timer callbacks don't trigger change detection.
 *   NOTE: If a timer needs to update the UI, use NgZone.run() or
 *   ChangeDetectorRef.detectChanges() manually.
 */
(window as any).__zone_symbol__PASSIVE_EVENTS = ['scroll', 'wheel', 'mousewheel', 'touchstart', 'touchmove', 'touchstart', 'touchend', 'touchcancel'];
(window as any).__Zone_disable_requestAnimationFrame = true;
(window as any).__Zone_disable_timers = true;
(window as any).__Zone_disable_setTimeout = true;
(window as any).__Zone_disable_setInterval = true;
(window as any).__Zone_disable_on_property = true;
(window as any).__zone_symbol__requestAnimationFrame = true;
(window as any).__zone_symbol__setTimeout = true;
(window as any).__zone_symbol__setInterval = true;
(window as any).__zone_symbol__on_property = true;
